// src/auth/RequireAuth.jsx
// 認証ガード。user が無ければログイン画面へリダイレクト。

import React from 'react';
import { Navigate } from 'react-router-dom';

export default function RequireAuth({ user, children }) {
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
